import { Box, Stack, Typography } from "@mui/material";
import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError() as any;

    return (
        <Box
            width="100%"
            height="100vh"
            display="flex"
            justifyContent="center"
            alignItems="center"
            id="error-page"
        >
            <Stack spacing={1} textAlign="center">
                <Typography variant="h4">Oops!</Typography>
                <Typography>
                    Sorry, an unexpected error has occurred.
                </Typography>
                <Typography>
                    <i>{error?.statusText || error?.message}</i>
                </Typography>
            </Stack>
        </Box>
    );
}
